$(() => {
    var collapseElements = document.querySelectorAll('.dilemmaBlock--optionBtn');

    if (!collapseElements || !collapseElements.length) return;

    console.log(collapseElements);

    collapseElements.forEach((element) => {
        element.addEventListener('click', function () {
            let targetElement = document.querySelector(this.getAttribute('data-target'));

            if (!targetElement) return;

            // Timeout to allow the collapse to display element before scrolling
            setTimeout(() => {
                targetElement.scrollIntoView({
                    behavior: 'smooth',
                    block: 'center'
                });
            }, 100);
        });
    });
});
